import { Pipe, PipeTransform } from '@angular/core'
import _ from 'lodash'

@Pipe({
    name: 'displayNameShort',
    standalone: false
})
export class DisplayNameShortPipe implements PipeTransform {
    transform(subject: any): string {
        if (!subject || !subject.opsubType) {
            return ''
        }

        let name = null

        if (subject.opsubType === 'OFO' || subject.opsubType === 'FO') {
            if (subject.prijmeni) {
                name = subject.prijmeni
            }
        } else if(subject.opsubType === 'SJM') {
            if (subject.nazev) {
                name = subject.nazev
            }
            else if (subject.prijmeni) {
                name = subject.prijmeni
            }
            if(name) {
                let partners = _.split(name, ' a ')
                if(partners[0]) {
                    name = _.split(partners[0], ' ')[0]
                }
                if(partners[1]) {
                    name += ' a ' + _.split(partners[1], ' ')[0]
                }
            }
            name = 'SJM ' + name
        } else {
            if (subject.nazev) {
                name = subject.nazev
            }
        }

        return name
    }
}
